// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgExit24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.25 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21L13.1987 20.9983L13.25 21C13.6642 21 14 20.6642 14 20.25L13.9932 20.1482C13.9435 19.7822 13.6297 19.5 13.25 19.5H6C5.72386 19.5 5.5 19.2761 5.5 19V5C5.5 4.72386 5.72386 4.5 6 4.5L13.1987 4.49827L13.25 4.5C13.6642 4.5 14 4.16421 14 3.75L13.9932 3.64823C13.9435 3.28215 13.6297 3 13.25 3ZM20.7803 11.2197L16.7803 7.21967C16.4874 6.92678 16.0126 6.92678 15.7197 7.21967L15.6471 7.30379C15.4292 7.5974 15.4534 8.01406 15.7197 8.28033L18.439 11H10.75C10.3358 11 10 11.3358 10 11.75L10.0068 11.8518C10.0565 12.2178 10.3703 12.5 10.75 12.5H18.438L15.7197 15.2197C15.4268 15.5126 15.4268 15.9874 15.7197 16.2803C16.0126 16.5732 16.4874 16.5732 16.7803 16.2803L20.7803 12.2803C21.0732 11.9874 21.0732 11.5126 20.7803 11.2197Z"
			/>
		</Svg>
	);
});
SvgExit24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgExit24;
